// extracted by mini-css-extract-plugin
export var active = "_gq-2";
export var recordingDot = "_gq-1";
export var recordingIndicator = "_gq-0";